"use strict";

/***************************************************************************
 * 
 * Application for the dimensioning of RC for shear according to SIA 262
 * 
 * Innovedum Project
 * 
 * Institute for Structural Engineering ETH Zürich
 * 
 **************************************************************************/

// Variables for the calculation


let acceptedValues;
let acceptValue;
let url = window.location.href;

if(url.indexOf("/en/") !== -1) {
    var lang = "en";
} else {
    var lang = "de";
}

/******************************
 *      Shear Reinforcement Parameters
 ******************************/
let dShear = parseInt($("#dShearRebar").val());
let sShear = parseInt($("#sShear").val());
let Asw = 2*dShear*dShear*Math.PI/4;
let aswperMeter = Asw/sShear*1000;

$("#dShearRebar").change(function(){
    dShear = parseInt($("#dShearRebar").val());
    updateShear();
}
);

$("#sShear").change(function(){
    sShear = parseInt($("#sShear").val());
    updateShear();
}
);

/***********************************
 *      Parameters for Stressfields
 ***********************************/
let alpha = 30;
let alphaRad = alpha*Math.PI/180;

let alphaSlider = document.getElementById('alpha');

noUiSlider.create(alphaSlider, {
    start: [30],
    range: {
        'min': 30,
        'max': 45
    },
    tooltips: true,
    step: 0.1,
    pips: {
        mode: 'count',
        values: 4,
        density: 7
    },
    format:{
        to: function(value){
            return Math.round(value*10)/10;
        },
        from: function(value){
            return value;
        }
    }
});

function updateAlpha(values){
    //$("#alphaOpt").val("unchecked");
    // if(values[0]!=alphaOpt){
    //     console.log('Here');
    //     document.getElementById("alphaOpt").checked = false;
    // }
    alpha = values[0];
    alphaRad = alpha*Math.PI/180;
    updateSteel();
    plotGeometry();
    upDateResistence();
    plotForces();
    alphaPlot();
}
// let alphaOpt;
// // Checking for ideal Slider
// $("#alphaOpt").change(function(){
    
//     //let alphaOptBool = $("#alphaOpt").prop("checked");
//     if(true){
//         if(math.max(VRdsArray) < math.min(VRdcArray)){
//             alert('Kein optimaler Winkel möglich. \nProbiere den Widerstand der Bügelbewehrung zu erhöhen.');
//             document.getElementById("alphaOpt").checked = false;
//         }
//         else if(math.max(VRdcArray) < math.min(VRdsArray)){
//             alert('Kein optimaler Winkel möglich. \nProbiere den Widerstand des Betonsteges zu erhöhen.');
//             document.getElementById("alphaOpt").checked = false;
//         }
//         else {
//             alphaRad = Math.asin(Math.sqrt((Asw/sShear*fsd)/(bw*kc*fcd)));
//             alpha = alphaRad*180/Math.PI;
//             alphaOpt = alpha;
//         }
//         alphaSlider.noUiSlider.set([alpha]);
//     }
// }
// );

function setAlphaOpt(){
    if(math.max(VRdsArray) < math.min(VRdcArray)){
        if(lang == "en"){
            alert("No optimal angle possible. \nTry increasing the resistance of the stirrup reinforcement.");
        }else{
            alert('Kein optimaler Winkel möglich. \nProbiere den Widerstand der Bügelbewehrung zu erhöhen.');
        }
        
        document.getElementById("alphaOpt").checked = false;
    }
    else if(math.max(VRdcArray) < math.min(VRdsArray)){
        if(lang == "en"){
            alert("No optimal angle possible. \nTry increasing the resistance of the concrete.");
        }else{
            alert('Kein optimaler Winkel möglich. \nProbiere den Widerstand des Betonsteges zu erhöhen.');
        }
        
        document.getElementById("alphaOpt").checked = false;
    }
    else {
        alphaRad = Math.asin(Math.sqrt((Asw/sShear*fsd)/(bw*kc*fcd)));
        alpha = alphaRad*180/Math.PI;
    }
    alphaSlider.noUiSlider.set([alpha]);
}

let kc = 0.55;


/*********************
 *      Concrete
 *********************/

//Concrete Parameters
let cType = parseInt($("#conType").val());
let fcd = Mat.Concrete.types[cType].fcd;
let Ec;

// Update concrete 
$("#conType").change(function(){
        cType = parseInt($("#conType").val());
        fcd = Mat.Concrete.types[cType].fcd;
        $("#conFc").html(Mat.Concrete.types[cType].fck);
        $("#conFcd").html(Mat.Concrete.types[cType].fcd);
        $("#conFcm").html(Mat.Concrete.types[cType].fcm);
        $("#conFctm").html(Mat.Concrete.types[cType].fctm);
        Ec = Math.round(Math.pow(Mat.Concrete.types[cType].fcm,(1/3))*10);
        $("#conEcm").html(Ec);
        $("#fcdDisp").html(Mat.Concrete.types[cType].fcd);
    }
);

/***********************
 *       Geometry
 ***********************/

//Section Geometry
let height = parseInt($("#conH").val());
let width =  parseInt($("#conB").val());;
let Ac = height*width;
let bw = width;

$("#conH").change(function(){
        height = parseInt($("#conH").val());
    }
);
$("#conB").change(function() {
        width = parseInt($("#conB").val());
        bw = width;
        $("#bwDisp").html(bw);
    }
);
/************************
 *        Steel
 ************************/
const steelDiameter = [12,16,20,22,26];

//Steel Parameters
let fsd = 435;
let fsk = 500;
let Es = 205;

/********************************
 *      Long. Reinforcement
 ********************************/
let cNom = parseInt($("#cNom").val());
let dRebar = steelDiameter[parseInt($("#dRebar").val())];

let dTop = cNom+dShear+dRebar/2;
let dBot = height-cNom-dShear-dRebar/2;
let dSide = cNom+dShear+dRebar/2; //Distance of Rebard from the side
let nRebar = 2;


let zShear = 0.9*dBot;

let AsTop = nRebar*dRebar*dRebar/4*math.pi;
let AsBot = nRebar*dRebar*dRebar/4*math.pi;

$("#nRebar").change(function(){
    if (typeDraw==1){
        for(let i=0;i<nRebar;i++) {
            scene.remove(cylinder[i]);
            scene.remove(cylinder[nRebar + i]);
        }
    }
    nRebar = parseInt($("#nRebar").val())+2;
    }
);
$("#dRebar").change(function(){
        dRebar = steelDiameter[parseInt($("#dRebar").val())];
    }
);
$("#cNom").change(function(){ 
        cNom = parseInt($("#cNom").val());
    }
);

/*******************
 *   Caorousel
 *******************/
$(document).ready(function () {
    $(".slkCarousel").slick({
        prevArrow: ".slick-prev",
        nextArrow: ".slick-next",
        appendDots: ".slkCarouselNav",
        dots: true,
        draggable: false,
    });
});

// Configuration for Plotly
var config = pltConfig;

/**************************
 *      Main Calculations
 **************************/
let VRds, VRdc;
let steelOrConc;

function upDateResistence(){
    VRds = Math.round(Asw/sShear*zShear*fsd/Math.tan(alphaRad)/1000);
    VRdc = Math.round(bw*zShear*kc*fcd*Math.sin(alphaRad)*Math.cos(alphaRad)/1000);
    $("#VRds").html(VRds);
    $("#VRdc").html(VRdc);
    $("#alphaDisp").html(Math.round(alpha*10)/10);
    $("#alphaDisp2").html(Math.round(alpha*10)/10);
    if(VRds < VRdc){
        steelOrConc = 0;
    }
    else {
        steelOrConc = 1;
    }
}

/*********************************
 *      Alpha Plot
 *********************************/
let alphaArray, alphaArrayCot, alphaArrayS;
let VRdsArray = [], VRdcArray = [];

function alphaPlot(){
    alphaArray = math.range(30,45,0.1);

    let i, a;
    for(i=0; i<alphaArray._data.length; i++){
        a = alphaArray._data[i]*math.pi/180;
        VRdsArray[i] =  Math.round(Asw/sShear*zShear*fsd/Math.tan(a)/1000);
        VRdcArray[i] =  Math.round(bw*zShear*kc*fcd*Math.sin(a)*Math.cos(a)/1000); 
    }

    let trace0 = {
        x: alphaArray._data,
        y: VRdsArray,
        mode: 'lines',
        line: {
            width: 1,
            color: 'rgb('+col.s.getRgb()+')',
            //dash: 'dash',
        },
        name: 'V<sub>Rd,s</sub>',
    };
  
    let trace1 = {
        x: alphaArray._data,
        y: VRdcArray,
        mode: 'lines',
        line: {
            width: 1,
            color: 'rgb('+col.c.getRgb()+')',
            
            //dash: 'dash',
        },
        name: 'V<sub>Rd,c</sub>',
    };
    let VRd;
    if(VRdc>VRds){
        VRd = VRds;
    }
    else{
        VRd = VRdc;
    }

    let VRdMax, VRdMin;
    if(math.max(VRdcArray)>math.max(VRdsArray)){
        VRdMax=math.max(VRdcArray);
    }
    else{
        VRdMax=math.max(VRdsArray);
    }
    if(math.min(VRdcArray)<math.min(VRdsArray)){
        VRdMin=math.min(VRdcArray);
    }
    else{
        VRdMin=math.min(VRdsArray);
    }
    let trace3={
        x: [29,alpha,alpha],
        y: [VRd,VRd, VRdMin-10],
        type: 'scatter',
        line: {
            color: 'rgb(100,100,100)',
            dash: 'dash',
            width: '1',
        },
        name: 'V<sub>Rd</sub>',
    }


    let data = [trace0, trace1, trace3];
    let layout = {
        hovermode: false,
        //width: 336,
        height:353,
        //autosize: true,
        margin: {
            r: 20,
            l: 60,
            t: 10,
            b: 40,
        },
        xaxis: {
            //domain: [0,1],
            title: 'α[°]',
            range: [30,45],
            fixedrange: true,
            
        },
        yaxis: {
            title: 'V<sub>Rd</sub>[kN]',
            //range: //[ Nd[2*resolution-2]+100, Nd[0]-100],
            range:[VRdMin-5, VRdMax+5],
            fixedrange: true,
        },
        showlegend: true,
        
    };

    if(window.checkMobile() == true){
        layout.dragmode = false;
    }

    Plotly.react('AlphaPlot', data,layout,config);
}

/***************************
 *     Update Classes
 ***************************/
// Function to check the validity of the values
function alertMinMax(htmlString, value, minValue, maxValue, textString, minString, maxString){
    let exceedMaxMin = false;
    let alertString;
    if(value < minValue){
        if(lang == "en"){
            alertString = textString+' is too small. Please choose a value between '+minValue+' and '+maxValue+'.\n\n'+minString;
        }else{
            alertString = textString+' ist zu klein. Bitte wähle einen Wert zwischen '+minValue+' und '+maxValue+'.\n\n'+minString;
        }
        
        exceedMaxMin = true;
    }
    else if(value > maxValue){
        if(lang == "en"){
            alertString = textString+' is too big. Please choose a value between '+minValue+' and '+maxValue+'.\n\n'+minString;
        }else{
            alertString = textString+' ist zu gross. Bitte wähle einen Wert zwischen '+minValue+' und '+maxValue+'.\n\n'+minString;
        }
        exceedMaxMin = true; 
    }
    else if (isNaN(value)){
        if(lang == "en"){
            alertString = "Please insert a number.";
        }else{
            alertString = "Bitte eine Nummer eingeben.";
        }
        exceedMaxMin = true;
    }

    if(exceedMaxMin){
        for(let i=0; i<htmlString.length;i++){
            document.getElementById(htmlString[i]).classList.add('is-invalid');
        }
        document.getElementById('Ctrl').classList.add('focus');
        alert(alertString);
        return exceedMaxMin;
    }else{
        for(let i=0; i<htmlString.length;i++){
            document.getElementById(htmlString[i]).classList.remove('is-invalid');
        }
        document.getElementById('Ctrl').classList.remove('focus');
    }
}


function checkValues(){
    // let acceptedValues = true;
    let exceedLimits = false;
    if(lang == "en"){
        exceedLimits = alertMinMax(['conH'], height, 200, 1000, 'The height h ', '','');
    } else {
        exceedLimits = alertMinMax(['conH'], height, 200, 1000, 'Die Höhe h ', '','');
    }
    
    if(exceedLimits){
        return false;
    }

    exceedLimits = false;
    if(lang == "en"){
        exceedLimits = alertMinMax(['conB'], width, 100, 500, 'The width b ', '','');
    } else {
        exceedLimits = alertMinMax(['conB'], width, 100, 500, 'Die Breite b ', '','');
    }
    
    if(exceedLimits){
        return false;
    }

    exceedLimits = false;
    if(lang == "en"){
        exceedLimits = alertMinMax(['cNom'], cNom, 10, 50, 'The reinforcement cover ', '','');
    } else {
        exceedLimits = alertMinMax(['cNom'], cNom, 10, 50, 'Die Bewehrungsüberdeckung ', '','');
    }
    
    if(exceedLimits){
        return false;
    }
    
    exceedLimits = false;
    if(lang == "en"){
        exceedLimits = alertMinMax(['sShear'], sShear, 50, 500, 'The spacing of the stirrup reinforcement ', '','');
    } else {
        exceedLimits = alertMinMax(['sShear'], sShear, 50, 500, 'Der Abstand der Bügelbewehrung ', '','');
    }
    
    if(exceedLimits){
        return false;
    }
    return true;
}


// Update Calculation when parameters where changed
$(".updCalc").change(function () {

    if(checkValues()){
        upDateResistence();
        plotForces();
        alphaPlot();
    }
    else{
        return;
    }
    
});

$(".updAll").change(function () {
    if(checkValues()){
        updateSteel();
        plotGeometry();
        upDateResistence();
        plotForces();
        update3DQS();
        alphaPlot();
    }
    else{
        return;
    }
    
});


function updateShear () {
    Asw = Math.round(2*dShear*dShear*Math.PI/4);
    $("#AswDisp").html(Asw);
    aswperMeter = Math.round(Asw/sShear*1000);
    $("#AswPerMeter").html(aswperMeter);
    $("#sDisp").html(sShear);
}

function updateSteel (){
    cNom = parseInt($("#cNom").val());
    //dRebar = steelDiameter[parseInt($("#dRebar").val())];
    dTop = cNom+dShear+dRebar/2;
    dBot = height-cNom-dShear-dRebar/2;
    dSide = cNom+dShear+dRebar/2; //Distance of Rebard from the side
    nRebar = 2;

    zShear = 0.9*dBot;
    $("#zShear").html(Math.round(zShear));
    $("#zDisp").html(Math.round(zShear));

    AsTop = nRebar*dRebar*dRebar/4*math.pi;
    AsBot = nRebar*dRebar*dRebar/4*math.pi;
}

/**********************************
 *  Plotting of Geomtrie
 **********************************/
function plotGeometry(){

    // Section
    let tempSec = new Group();
    tempSec.addElm(new Rectangle(width, height, width/2, height/2).setFill(col.c_vis.getRgb()));
    tempSec.addElm(new Circle(dSide, height-dBot, dRebar/2).setFill(col.base.getRgb()));
    tempSec.addElm(new Circle(dSide, height-dTop, dRebar/2).setFill(col.base.getRgb()));
    tempSec.addElm(new Circle(width-dSide, height-dBot, dRebar/2).setFill(col.base.getRgb()));
    tempSec.addElm(new Circle(width-dSide, height-dTop, dRebar/2).setFill(col.base.getRgb()));

    let pltSec = tempSec.getPlotData();

    //Shear Reinforcement in the Crosssection
    let tempShear = new Group();
    tempShear.addElm(new Circle(dSide, height-dBot, dRebar/2+dShear, 90).rotate(180,dSide, height-dBot ));
    tempShear.addElm(new Circle(dSide, height-dTop, dRebar/2+dShear, 90).rotate(90,dSide, height-dTop ));
    tempShear.addElm(new Circle(width-dSide, height-dBot, dRebar/2+dShear, 90).rotate(270,width-dSide, height-dBot));
    tempShear.addElm(new Circle(width-dSide, height-dTop, dRebar/2+dShear, 90).rotate(0,width-dSide, height-dTop ));
    tempShear.addElm(new Line([dSide-dRebar/2-dShear, dSide-dRebar/2-dShear],[height-dBot, height-dTop]));
    tempShear.addElm(new Line([dSide-dRebar/2, dSide-dRebar/2],[height-dBot, height-dTop]));
    tempShear.addElm(new Line([width-dSide+dRebar/2+dShear, width-dSide+dRebar/2+dShear],[height-dBot, height-dTop]));
    tempShear.addElm(new Line([width-dSide+dRebar/2, width-dSide+dRebar/2],[height-dBot, height-dTop]));
    tempShear.addElm(new Line([dSide, width-dSide],[height-dBot-dRebar/2, height-dBot-dRebar/2]));
    tempShear.addElm(new Line([dSide, width-dSide],[height-dBot-dRebar/2-dShear, height-dBot-dRebar/2-dShear]));
    tempShear.addElm(new Line([dSide, width-dSide],[height-dTop+dRebar/2, height-dTop+dRebar/2]));
    tempShear.addElm(new Line([dSide, width-dSide],[height-dTop+dRebar/2+dShear, height-dTop+dRebar/2+dShear]));
    let pltShear = tempShear.getPlotData();

    // Parameters for Sideview
    let leftOfBearing = 50;             // Distance of the bearing from the edge
    let shearlength = zShear/Math.tan(alphaRad);    //Lenght z*cot(alpha)
    let lengthSideMax = zShear/Math.tan(math.pi/6)+leftOfBearing;
    let lengthSide = Math.round(leftOfBearing+shearlength); //Total length of the side View

    let distance = height/4;  //Distance between the Section and the Sideview

    //Side View
    let tempSide = new Group();
    tempSide.addElm(new Rectangle(lengthSide, height, width+distance+lengthSide/2, height/2).setFill(col.c_vis.getRgb()));
    tempSide.addElm(new Rectangle(lengthSide, dRebar, width+distance+lengthSide/2, height-dBot).setFill(col.bg.getRgb()));
    tempSide.addElm(new Rectangle(lengthSide, dRebar, width+distance+lengthSide/2, height-dTop).setFill(col.bg.getRgb()));

    //Shear Rebars
    let i=0;
    while (sShear/2+i*sShear < lengthSide){
        tempSide.addElm(new Rectangle(dShear, height-2*dTop-dRebar, width + distance + sShear / 2 + i * sShear, height / 2).setFill(col.bg.getRgb()));
        tempSide.addElm(new Circle(width+distance+sShear/2+i*sShear, height-dBot -dRebar / 2 - dShear / 2, dShear / 2).setFill(col.bg.getRgb()));
        tempSide.addElm(new Circle(width+distance+sShear/2+i*sShear, height - dTop + dRebar / 2 + dShear / 2, dShear / 2).setFill(col.bg.getRgb()));
        i++;
    }

    // Support
    let xSupport = width+distance+leftOfBearing;
    tempSide.addElm(new Support(xSupport,0,1,50));

    //Parallel Field
    tempSide.addElm(new ParallelField([xSupport,xSupport+shearlength,xSupport+2*shearlength,xSupport+shearlength],
        [height-dBot,  height-dBot+zShear,  height-dBot+zShear, height-dBot]));
    tempSide.addElm(new Rectangle(shearlength,height, width+distance+lengthSide+shearlength/2, height/2).setColor(col.bg.getRgb()).setFill(col.bg.getRgba()));
    let pltSide = tempSide.getPlotData();

    // Dimensioning Lines
    let offset = height/5;
    let offsetText = height/20;
    let r = 6;
    let offsetAngle = height/5;
    let tempDim = new Group();
    tempDim.addElm(new DimLine([xSupport,0],[xSupport+shearlength,0],'z cot(α)', r,-offset,offsetText));
    tempDim.addElm(new DimLine([xSupport+shearlength,height],[xSupport+shearlength,height-dBot],'d', r,offset,offsetText/2));
    tempDim.addElm(new DimLine([width+distance+sShear/2,height],[width+distance+3*sShear/2,height],'s', r,offset/2,offsetText));
    tempDim.addElm(new DimLine([xSupport+shearlength,height-dBot+zShear],[xSupport+shearlength,height-dBot],'z',  r,offset/2,offsetText/2));
    tempDim.addElm(new DimLine([width,height],[width,0],'h',  r,offset/2,offsetText/2));
    tempDim.addElm(new DimLine([0,0],[width,0],'bw',  r,-offset,offsetText));
    tempDim.addElm(new Circle(xSupport, height-dBot, 2*offsetAngle, alpha));
    tempDim.addElm(new Text(xSupport+offsetAngle, height-dBot+offsetAngle*Math.sin(alphaRad/2), 'α'));

    let pltDim = tempDim.getPlotData();

    // Acting Forces
    let layout = {
        hovermode: false,
        height: 300,
        margin: {
            r: 0,
            l: 10,
            t: 10,
            b: 40,
        },

        xaxis: {
            //autorange: true,
            range: [-10,width+distance+lengthSideMax+2*offset],
            zeroline: false,
            showgrid: false,
            showline: false,
            showticklabels: false,

        },
        yaxis: {
            autorange: true,
            zeroline: false,
            showgrid: false,
            showline: false,
            showticklabels: false,
            scaleanchor: 'x', 
        },
        showlegend: false,
    };

    var data = pltSec.data;
    data.push(... pltShear.data);
    data.push(... pltSide.data);
    data.push(... pltDim.data);

    if(window.checkMobile() == true){
        layout.dragmode = false;
    }

    Plotly.react('Geometrie2D', data, layout, config);
}

/****************************
 *      Plotting of Forces
 ****************************/
function plotForces(){

    // Parameters for Sideview
    let shearlength = zShear/Math.tan(alphaRad);    //Lenght z*cot(alpha)
    let shearlengthMax = zShear/Math.tan(math.pi/6);
    //Side View
    let tempSide = new Group();
    //Parallel Field
    tempSide.addElm(new Rectangle(shearlength, dRebar, shearlength/2, height-dBot).setFill(col.bg.getRgb()).setZIndex(110));
    tempSide.addElm(new ParallelField([0,shearlength,2*shearlength,shearlength],
        [height-dBot,  height-dBot+zShear,  height-dBot+zShear, height-dBot]).setColor(col.bg.getRgb()).setFill(col.c_vis.getHex()));
    tempSide.addElm(new Rectangle(shearlength,height,3*shearlength/2, height/2).setColor(col.bg.getRgb()).setFill(col.bg.getRgba()));
    let pltSide = tempSide.getPlotData();

    //Forces
    let forceLength = 100;
    let forceOffset = 10;
    let textOffset = height/20;
    let tempForces = new Group();
    let scaleArrow = height/5;

    let sColor; // Color of Steelstress
    let cColor; // Color of Concrete Stress
    let vdText;

    let shearForceLength;
    let failureText;
    if (steelOrConc==0){
        shearForceLength= VRds/3;
        sColor = [255,0,0];
        cColor = col.c.getRgb();
        vdText = '<i>V<sub>d</sub>= V<sub>Rd,s</sub></i>';
        if(lang == "en"){
            failureText = "Yielding of the stirrup reinforcement.";
        } else {
            failureText = "Fliessen der Bügelbewehrung.";
        }
    }
    else{
        shearForceLength= VRdc/3;
        sColor = col.s.getRgb();
        cColor = [255,0,0];
        vdText = '<i>V<sub>d</sub>= V<sub>Rd,c</sub></i>';
        if(lang == "en"){
            failureText = "Compression failure of the concrete.";
        } else {
            failureText = "Druckversagen des Stegbetons.";
        }
    }
    $("#failureMode").html(failureText);

    //Compression Force
    tempForces.addElm(new Arrow(shearlength+forceOffset, height-dBot+zShear, forceLength, 0, scaleArrow).rotate(-90, shearlength+forceOffset,height-dBot+zShear)
        .setColor(col.c.getRgb()).setFill(col.c.getRgba()));
    tempForces.addElm(new Text(shearlength+forceOffset+3*forceLength/4, height-dBot+zShear+textOffset, '<i>F<sub>c</sub></i>'));
    //Tension Force
    tempForces.addElm(new Arrow(shearlength+forceOffset+forceLength, height-dBot, forceLength, 0,scaleArrow).rotate(90,shearlength+forceOffset+forceLength,height-dBot)
        .setColor(col.s.getRgb()).setFill(col.s.getRgba()));
    tempForces.addElm(new Text(shearlength+forceOffset+forceLength/4, height-dBot+textOffset, '<i>F<sub>t</sub></i>'));

    //Shear Force
    forceLength = shearForceLength/Math.sin(alphaRad);
    tempForces.addElm(new Arrow(shearlength+forceOffset, height-dBot+zShear/2, forceLength, 0, scaleArrow).rotate(-90+alpha,shearlength+forceOffset,height-dBot+zShear/2)
        .setColor(col.c.getRgb()).setFill(col.c.getRgba()));
    tempForces.addElm(new Text(shearlength+forceOffset+forceLength*Math.cos(alphaRad)/2,
        height-dBot+zShear/2+3*forceLength*Math.sin(alphaRad)/4+textOffset, '<i>F<sub>cw</sub></i>').setColor(col.c.getRgb()).setFill(col.c.getRgba()));
    // V_d*cot(alpha)
    tempForces.addElm(new Line([shearlength+forceOffset,shearlength+forceOffset+forceLength*Math.cos(alphaRad)],
        [height-dBot+zShear/2,height-dBot+zShear/2]).setColor(col.c.getRgb()).setFill(col.c.getRgba()));
    // V_d
    tempForces.addElm(new Line([shearlength+forceOffset+forceLength*Math.cos(alphaRad),shearlength+forceOffset+forceLength*Math.cos(alphaRad) ],
        [height-dBot+zShear/2,height-dBot+zShear/2+forceLength*Math.sin(alphaRad)] ).setColor(col.c.getRgb()).setFill(col.c.getRgba()));
    tempForces.addElm(new Text(shearlength+forceOffset+forceLength*Math.cos(alphaRad)+3*textOffset
        ,height-dBot+zShear/2+forceLength*Math.sin(alphaRad)/2, vdText ));


    // Stress in conrete
    let sigmaSide = height/10;
    let sigmaCenterX = 3*shearlength/4;
    let baseY = height-dBot;
    let sigmaCenterY = baseY+3*shearlength/4*Math.tan(alphaRad/2);
    let sigmaArrowLength = height/10;
    let scaleArrowConcStress = height/8;

    tempForces.addElm(new Rectangle(sigmaSide, sigmaSide, sigmaCenterX, sigmaCenterY).rotate(alpha, sigmaCenterX, sigmaCenterY)
        .setColor(cColor).setFill(cColor));
    tempForces.addElm(new Arrow(sigmaCenterX, sigmaCenterY, sigmaArrowLength,0,scaleArrowConcStress)
       .rotate(90+alpha, sigmaCenterX, sigmaCenterY).move(Math.cos(alphaRad)*-sigmaSide/2,Math.sin(alphaRad)*-sigmaSide/2).setColor(cColor).setFill(cColor));
    tempForces.addElm(new Arrow(sigmaCenterX, sigmaCenterY, sigmaArrowLength,0,scaleArrowConcStress)
        .rotate(-90+alpha, sigmaCenterX, sigmaCenterY).move(Math.cos(alphaRad)*sigmaSide/2,Math.sin(alphaRad)*sigmaSide/2).setColor(cColor).setFill(cColor));
    tempForces.addElm(new Text(sigmaCenterX-sigmaArrowLength, sigmaCenterY-1.1*sigmaSide, '-σ<sub>c3</sub>'));

    // Shear Tension Stress
    let lFw=0;
    let deltalFw = shearlength/7;

    let i = 0;
    while(lFw < shearlength-1){
        lFw = i*deltalFw;
        tempForces.addElm(new Arrow(lFw, baseY+lFw*Math.tan(alphaRad)+sigmaArrowLength,sigmaArrowLength, 0,scaleArrowConcStress).rotate(180,lFw,baseY+lFw*Math.tan(alphaRad)+sigmaArrowLength)
            .setColor(sColor).setFill(sColor));
        i++;
    }
    tempForces.addElm(new Text(shearlength/2, baseY+shearlength/2*Math.tan(alphaRad)+sigmaArrowLength, '<i>f<sub>w</sub></i>'));

    let pltForces = tempForces.getPlotData();

    // Dimensioning Lines
    let offset = height/5;
    let offsetText = height/10;
    let r = 6;
    let offsetAngle = height/6;
    let tempDim = new Group();
    tempDim.addElm(new DimLine([0,0],[shearlength,0],'<i>z cot(α)</i>', r, -offset, offsetText));
    tempDim.addElm(new DimLine([shearlength+3*offset,height-dBot+zShear],[shearlength+3*offset,height-dBot],'<i>z</i>',r ,offset, offsetText));
    tempDim.addElm(new Circle(0, height-dBot, 2*offsetAngle, alpha));
    tempDim.addElm(new Text(offsetAngle, height-dBot+offsetAngle*Math.sin(alphaRad/2), 'α'));

    let pltDim = tempDim.getPlotData();


    let layout = {
        hovermode: false,
        height: 353,
        margin: {
            r: 0,
            l: 10,
            t: 10,
            b: 40,
        },

        xaxis: {
            range:[-offset, shearlengthMax+4*offset+offsetText*4],
            zeroline: false,
            showgrid: false,
            showline: false,
            showticklabels: false,
        },
        yaxis: {
           
            autorange: true,
            zeroline: false,
            showgrid: false,
            showline: false,
            showticklabels: false,
            scaleanchor: 'x',
        },
        showlegend: false,
    };

    var data = pltSide.data;
    data.push(... pltSide.data);
    data.push(... pltForces.data);
    data.push(... pltDim.data);

    if(window.checkMobile() == true){
        layout.dragmode = false;
    }

    Plotly.react('Forces2D', data, layout, config);
}

/*******************************
 *      Plotting of 3D Element
 *******************************/
var container, scene, camera, renderer, controls, geometry, material, pointLight, pointLight2, pointLight3, pointLight4;
var cylinder = [];
let dist;
var outterQS, concreteMat, rectangle, light;

var path, geoPath;
var tubePath = [];

let nShearRebar;


function plot3DQuerschnitt(){
    container = document.querySelector("#plot3DQS");
    let length3D = 2000;
    let heightTHREE = container.clientHeight;
    let widthTHREE = container.clientWidth;
   
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(45, widthTHREE/heightTHREE, 0.1, 10000);

    renderer = new THREE.WebGLRenderer( );
    renderer.setSize(widthTHREE,heightTHREE,1000);
    renderer.setClearColor(0xffffff,1);
    renderer.sortObjects = false;
    container.appendChild(renderer.domElement);

    controls = new THREE.OrbitControls( camera, container );
    camera.position.set(3/4*length3D,height/2,3/4*length3D);
    controls.update();

    //Construction of Rebars
    geometry = new THREE.CylinderGeometry(dRebar/2,dRebar/2,length3D+50,100,1, false);
    material = new THREE.MeshStandardMaterial({color: 0x555555, side:THREE.DoubleSide});
    material.roughness = 0.8;

    dist = (width-2*dSide)/(nRebar-1);
    for(let i=0;i<nRebar;i++){
        cylinder[i] = new THREE.Mesh(geometry, material);
        cylinder[i].rotation.x = math.pi/2;
        cylinder[i].rotation.z = math.pi/2;
        cylinder[i].position.set(0,height/2-dTop,-width/2+dSide+i*dist);
        scene.add(cylinder[i]);

        cylinder[nRebar+i] = new THREE.Mesh(geometry, material);
        cylinder[nRebar+i].rotation.x = math.pi/2;
        cylinder[nRebar+i].rotation.z = math.pi/2;
        cylinder[nRebar+i].position.set(0,height/2-dBot,-width/2+dSide+i*dist);
        scene.add(cylinder[nRebar+i]);
    }

    //Concete Section
    outterQS = new THREE.BoxGeometry(length3D,height, width);
    concreteMat = new THREE.MeshStandardMaterial({color: 0xbbbbbb, transparent: true, opacity: 0.9, side:THREE.DoubleSide});
    concreteMat.metalness = 0;
    concreteMat.roughness = 1;
    rectangle = new THREE.Mesh(outterQS, concreteMat);
    scene.add(rectangle);

    //Shear Reinforcement
    let posZ = height/2-dBot-dRebar/2-dShear/2;
    let negZ = height/2-dTop+dRebar/2+dShear/2;
    let negX  = -width/2+dSide-dRebar/2-dShear/2;
    let posX = width/2-dSide+dRebar/2+dShear/2;
    let offset = 0;

    nShearRebar = Math.floor(length3D/sShear);
    let xShearRebarInit;
    if (nShearRebar%2==0){
        xShearRebarInit = sShear/2-(nShearRebar)/2*sShear;
    }
    else {
        xShearRebarInit = -length3D/2+(length3D-nShearRebar*sShear)/2;
        nShearRebar += 1;
    }
    let xShearRebar = xShearRebarInit;

    for(let i=0;i<nShearRebar;i++){
        xShearRebar = xShearRebarInit+sShear*i;
        path = new THREE.CatmullRomCurve3([
            
            //Bottom left
            new THREE.Vector3(xShearRebar,negZ,negX),
            new THREE.Vector3(xShearRebar,negZ,negX+offset),
            new THREE.Vector3(xShearRebar,negZ,0),
            //Top Right
            new THREE.Vector3(xShearRebar,negZ,posX-offset),
            new THREE.Vector3(xShearRebar,negZ,posX),
            new THREE.Vector3(xShearRebar,negZ-offset,posX),
            new THREE.Vector3(xShearRebar,0,posX),
            new THREE.Vector3(xShearRebar,posZ+offset,posX),
            new THREE.Vector3(xShearRebar,posZ,posX),
            new THREE.Vector3(xShearRebar,posZ,posX-offset),
            new THREE.Vector3(xShearRebar,posZ,0),
            new THREE.Vector3(xShearRebar,posZ,negX+offset),
            new THREE.Vector3(xShearRebar,posZ,negX),
            new THREE.Vector3(xShearRebar,posZ+offset,negX),
            new THREE.Vector3(xShearRebar,0,negX),
            new THREE.Vector3(xShearRebar,negZ-offset,negX),

        ]);
        path.closed = true;
        path.curveType = 'centripetal'; //centripetal, chordal and catmullrom.

        geoPath = new THREE.TubeGeometry(path, 128, dShear/2, 8);
        tubePath[i] = new THREE.Mesh(geoPath, material);
        scene.add(tubePath[i]);
    }

    // create a point light
    light = new THREE.AmbientLight( 0x404040 ); // soft white light
    scene.add( light );

    var lightColor = 0xaaaaaa;
    pointLight = new THREE.PointLight( lightColor );
    pointLight.position.set(200,0,500);
    pointLight2 = new THREE.PointLight( lightColor );
    pointLight2.position.set(-200,0,-500);
    pointLight3 = new THREE.PointLight( lightColor);
    pointLight3.position.set(500,600,200);
    pointLight4 = new THREE.PointLight( lightColor );
    pointLight4.position.set(-500,-600,-200);
    scene.add(pointLight, pointLight2, pointLight3, pointLight4);

    function updateHeightWidth(){
        heightTHREE = container.clientHeight;
        widthTHREE = container.clientWidth;
        camera.aspect = widthTHREE/heightTHREE;
        camera.updateProjectionMatrix();
        renderer.setSize(widthTHREE,heightTHREE,1000);
    }


    function animate() {
        requestAnimationFrame( animate );
        updateHeightWidth();
        controls.update();
        controls.enableKeys = false;
        renderer.render( scene, camera );
    }
    animate();
}

function update3DQS(){
    let length3D = 2000;
    //camera.position.set(3/4*length3D,height/2,3/4*length3D);
    dist = (width-2*dSide)/(nRebar-1);
    geometry = new THREE.CylinderGeometry(dRebar/2,dRebar/2,length3D+50,100,1, false);

    for(let i=0;i<nRebar;i++){
        scene.remove(cylinder[i]);
        scene.remove(cylinder[nRebar+i]);
        cylinder[i] = new THREE.Mesh(geometry, material);
        cylinder[i].rotation.x = math.pi/2;
        cylinder[i].rotation.z = math.pi/2;
        cylinder[i].position.set(0,height/2-dTop,-width/2+dSide+i*dist);
        scene.add(cylinder[i]);

        cylinder[nRebar+i] = new THREE.Mesh(geometry, material);
        cylinder[nRebar+i].rotation.x = math.pi/2;
        cylinder[nRebar+i].rotation.z = math.pi/2;
        cylinder[nRebar+i].position.set(0,height/2-dBot,-width/2+dSide+i*dist);
        scene.add(cylinder[nRebar+i]);
    }

    //Concete Section
    scene.remove(rectangle);
    outterQS = new THREE.BoxGeometry(length3D, height,width);

    rectangle = new THREE.Mesh(outterQS, concreteMat);

    scene.add(rectangle);

    //Shear Reinforcement
    
    let posZ = height/2-dBot-dRebar/2-dShear/2;
    let negZ = height/2-dTop+dRebar/2+dShear/2;
    let negX  = -width/2+dSide-dRebar/2-dShear/2;
    let posX = width/2-dSide+dRebar/2+dShear/2;
    let offset = 0;

    for(let i=0;i<nShearRebar;i++){
        scene.remove(tubePath[i]);
    }

    nShearRebar = Math.floor((length3D)/sShear);
    
    let xShearRebarInit;
    if (nShearRebar%2==0){
        xShearRebarInit = sShear/2-(nShearRebar)/2*sShear;
    }
    else {
        xShearRebarInit = -length3D/2+(length3D-nShearRebar*sShear)/2;
        nShearRebar += 1;
    }
    let xShearRebar = xShearRebarInit;

    for(let i=0;i<nShearRebar;i++){
        xShearRebar = xShearRebarInit+sShear*i;
        path = new THREE.CatmullRomCurve3([
            
            //Bottom left
            new THREE.Vector3(xShearRebar,negZ,negX),
            new THREE.Vector3(xShearRebar,negZ,negX+offset),
            new THREE.Vector3(xShearRebar,negZ,0),
            //Top Right
            new THREE.Vector3(xShearRebar,negZ,posX-offset),
            new THREE.Vector3(xShearRebar,negZ,posX),
            new THREE.Vector3(xShearRebar,negZ-offset,posX),
            new THREE.Vector3(xShearRebar,0,posX),
            new THREE.Vector3(xShearRebar,posZ+offset,posX),
            new THREE.Vector3(xShearRebar,posZ,posX),
            new THREE.Vector3(xShearRebar,posZ,posX-offset),
            new THREE.Vector3(xShearRebar,posZ,0),
            new THREE.Vector3(xShearRebar,posZ,negX+offset),
            new THREE.Vector3(xShearRebar,posZ,negX),
            new THREE.Vector3(xShearRebar,posZ+offset,negX),
            new THREE.Vector3(xShearRebar,0,negX),
            new THREE.Vector3(xShearRebar,negZ-offset,negX),

        ]);
        path.closed = true;
        path.curveType = 'centripetal'; //centripetal, chordal and catmullrom.

        geoPath = new THREE.TubeGeometry(path, 128, dShear/2, 8);
        tubePath[i] = new THREE.Mesh(geoPath, material);
        scene.add(tubePath[i]);
    }
}

/****************
 *      Main
 ****************/
upDateResistence();
plotGeometry();
plotForces();
plot3DQuerschnitt();
alphaPlot();

//alphaSlider.noUiSlider.on('set', updateAlpha);

if(window.checkMobile() == true){
    alphaSlider.noUiSlider.on('set', updateAlpha);
}
else {
    alphaSlider.noUiSlider.on('update', updateAlpha); 
}